<div class="wrapper">
  <mat-sidenav-container
    class="sidenav-container"
    [class.mobile-menu-opened]="isMenuOpen"
    (backdropClick)="closeMenu()">
    <mat-sidenav [(opened)]="isThirdLevelMenuOpen" mode="over" position="end" class="sidenav thirdLevelLevel">
      <bau365-shell-mobile-layer-header (closeMenu)="closeMenu()"></bau365-shell-mobile-layer-header>
      @for (fair of allFairs$ | async; track identifyFairConfig($index, fair)) { @if (fair.id ===
      this.currentThirdLevelFairId) {
      <div class="sidenav-top">
        <hr />
        <div class="menuLevelBack">
          <a (click)="closeSubMenu(true)" class="header-link menuLevelBack__link">
            <mat-icon class="menuLevelBack__icon">chevron_left</mat-icon>
            {{ fair.name }}
          </a>
        </div>
        <hr />
        <a
          (click)="closeMenu()"
          [routerLink]="['/fairs', fair.id, 'exhibitors']"
          class="header-link"
          routerLinkActive="header-link-active"
          i18n="@@uiShell-pastFairExhibitorDirectoryLinkLabel">
          Ausstellerverzeichnis
        </a>
        @if (fair['hallplan'] && (hallplanEnabled$ | async)) {
        <a
          (click)="closeMenu()"
          [routerLink]="['/fairs', fair.id, 'hall-plan']"
          class="header-link"
          routerLinkActive="header-link-active"
          i18n="@@uiShell-pastFairHallplanLinkLabel">
          Hallenplan
        </a>
        } @if (!fair['discoveryHidden'] && (searchEnabled$ | async)) {
        <a
          (click)="closeMenu()"
          [routerLink]="['/fairs', fair.id, 'search']"
          class="header-link"
          routerLinkActive="header-link-active"
          i18n="@@uiShell-pastFairSearchLinkLabel">
          Entdecken
        </a>
        } @if ((togglesFacade.flag('kill-program') | async) !== true) { @if (fair['program'] && (programEnabled$ |
        async)) {
        <a
          (click)="closeMenu()"
          [routerLink]="['/fairs', fair.id, 'program']"
          class="header-link"
          routerLinkActive="header-link-active"
          i18n="@@uiShell-pastFairProgramLinkLabel">
          Rahmenprogramm
        </a>
        } }
      </div>
      } }
    </mat-sidenav>
    <mat-sidenav-content>
      <mat-sidenav-container class="sidenav-container" (backdropClick)="closeMenu()">
        <mat-sidenav [(opened)]="isSecondLevelMenuOpen" mode="over" position="end" class="sidenav secondLevel">
          <bau365-shell-mobile-layer-header (closeMenu)="closeMenu()"></bau365-shell-mobile-layer-header>
          @if (fairsConfiguration$ | async; as fairsConfiguration) {
          <div class="sidenav-top">
            <hr />
            @if (this.currentSecondLevelFairId) { @if (this.currentSecondLevelFairId === fairsConfiguration.bauInsights)
            {
            <div class="menuLevelBack">
              <a (click)="closeSubMenu()" class="header-link menuLevelBack__link year-round-event">
                <mat-icon class="menuLevelBack__icon">chevron_left</mat-icon>
                Insights
              </a>
            </div>
            <hr />
            <a
              (click)="closeMenu()"
              [routerLink]="['/fairs', fairsConfiguration.bauInsights, 'exhibitors']"
              class="header-link"
              routerLinkActive="header-link-active"
              i18n="@@uiShell-insightsCompanyDirectoryLinkLabel">
              Unternehmensverzeichnis
            </a>
            @if ( !fairsConfiguration.fairs[fairsConfiguration.bauInsights].discoveryHidden &&
            fairsConfiguration.bauInsights ) {
            <a
              (click)="closeMenu()"
              [routerLink]="['/fairs', fairsConfiguration.bauInsights, 'search']"
              class="header-link"
              routerLinkActive="header-link-active"
              i18n="@@uiShell-insightsSearchLinkLabel">
              Entdecken
            </a>
            } } @if (this.currentSecondLevelFairId === fairsConfiguration.activeFair) {
            <div class="menuLevelBack">
              <a (click)="closeSubMenu()" class="header-link menuLevelBack__link">
                <mat-icon class="menuLevelBack__icon">chevron_left</mat-icon>
                {{ fairsConfiguration.fairs[fairsConfiguration.activeFair].name }}
              </a>
            </div>
            <hr />
            <a
              (click)="closeMenu()"
              [routerLink]="['/fairs', fairsConfiguration.activeFair, 'exhibitors']"
              class="header-link"
              routerLinkActive="header-link-active"
              i18n="@@uiShell-activeFairExhibitorDirectoryLinkLabel"
              >Ausstellerverzeichnis</a
            >
            @if ( fairsConfiguration.fairs[fairsConfiguration.activeFair].hallplan && (hallplanEnabled$ | async) ) {
            <a
              (click)="closeMenu()"
              [routerLink]="['/fairs', fairsConfiguration.activeFair, 'hall-plan']"
              class="header-link"
              routerLinkActive="header-link-active"
              i18n="@@uiShell-pastFairHallplanLinkLabel">
              Hallenplan
            </a>
            } @if ( !fairsConfiguration.fairs[fairsConfiguration.activeFair].discoveryHidden && (searchEnabled$ | async)
            ) {
            <a
              (click)="closeMenu()"
              [routerLink]="['/fairs', fairsConfiguration.activeFair, 'search']"
              class="header-link"
              routerLinkActive="header-link-active"
              i18n="@@uiShell-activeFairSearchLinkLabel">
              Entdecken
            </a>
            } @if ((togglesFacade.flag('kill-program') | async) !== true) { @if (
            fairsConfiguration.fairs[fairsConfiguration.activeFair].program && programEnabled$ | async ) {
            <a
              (click)="closeMenu()"
              [routerLink]="['/fairs', fairsConfiguration.activeFair, 'program']"
              class="header-link"
              routerLinkActive="header-link-active"
              i18n="@@uiShell-pastFairProgramLinkLabel">
              Rahmenprogramm
            </a>
            } } } } @else {
            <div class="menuLevelBack">
              <a (click)="closeSubMenu()" class="header-link menuLevelBack__link">
                <mat-icon class="menuLevelBack__icon">chevron_left</mat-icon>
                <span i18n="@@uiShell-allFairsLinkLabelBackMobile">Alle anzeigen</span>
              </a>
            </div>
            <hr />
            @if (fairsConfiguration.fairs[fairsConfiguration.activeFair]) {
            <div class="activeFairs">
              <span class="submenuLinkLabel" i18n="@@uiShell-activeFairsLabel"> Aktuelle Veranstaltungen </span>
              <a
                (click)="openSubMenu(fairsConfiguration.activeFair, true)"
                [class.header-link-active]="isMenuItemActive(['/fairs', fairsConfiguration.activeFair])"
                class="header-link"
                routerLinkActive="header-link-active">
                {{ fairsConfiguration.fairs[fairsConfiguration.activeFair].name }}
                <mat-icon class="header-link__icon">chevron_right</mat-icon>
              </a>
            </div>
            }
            <div class="pastFairs">
              <span class="submenuLinkLabel" i18n="@@uiShell-pastFairsLabel"> Vergangene Veranstaltungen </span>
              @for (pastFair of pastFairs$ | async; track identifyFairConfig($index, pastFair)) { @if (!pastFair.hidden)
              {
              <a
                (click)="openSubMenu(pastFair.id, true)"
                [class.header-link-active]="isMenuItemActive(['/fairs', pastFair.id ?? ''])"
                class="header-link"
                routerLinkActive="header-link-active">
                {{ pastFair.name }}
                <mat-icon class="header-link__icon">chevron_right</mat-icon>
              </a>
              } }
            </div>
            }
          </div>
          }
        </mat-sidenav>
        <mat-sidenav-content>
          <mat-sidenav-container class="sidenav-container sidenav-container__inner" (backdropClick)="closeMenu()">
            <mat-sidenav
              #sidenav
              autoFocus="false"
              mode="over"
              position="end"
              [(opened)]="isFirstLevelMenuOpen"
              class="sidenav">
              <bau365-shell-mobile-layer-header (closeMenu)="closeMenu()"></bau365-shell-mobile-layer-header>
              @if (fairsConfiguration$ | async; as fairsConfiguration) {
              <div class="sidenav-top">
                @if (detailed) { @if (!isLoggedIn) {
                <div class="header-login">
                  <a
                    [href]="loginLink"
                    class="header-link__button header-link__button--offset"
                    mat-flat-button
                    color="primary"
                    i18n="@@uiShell-signinLinkLabel">
                    Anmelden
                  </a>
                </div>
                }
                <hr />
                @if (isLoggedIn) {
                <a
                  (click)="closeMenu()"
                  [routerLink]="['/', 'newsfeed']"
                  class="header-link"
                  [routerLinkActive]="'header-link-active'"
                  [routerLinkActiveOptions]="{
                    matrixParams: 'ignored',
                    queryParams: 'ignored',
                    paths: 'exact',
                    fragment: 'ignored'
                  }">
                  <span i18n="@@uiShell-sideNavHomeLinkLabel">Startseite</span>
                  <mat-icon class="header-link__icon">home</mat-icon>
                </a>
                }
                <a
                  [class.header-link-active]="isMenuItemActive(['/fairs', fairsConfiguration.bauInsights])"
                  (click)="openSubMenu(fairsConfiguration.bauInsights)"
                  class="header-link year-round-event"
                  data-text="Insights">
                  Insights
                  <mat-icon class="header-link__icon">chevron_right</mat-icon>
                </a>
                @if (fairsConfiguration.fairs[fairsConfiguration.activeFair]; as activeFair) {
                <a
                  [class.header-link-active]="isMenuItemActive(['/fairs', fairsConfiguration.activeFair])"
                  (click)="openSubMenu(fairsConfiguration.activeFair)"
                  class="header-link">
                  {{ activeFair.name }}
                  <mat-icon class="header-link__icon">chevron_right</mat-icon>
                </a>
                }
                <a
                  [class.header-link-active]="isAllFairsMenuItemActive(['/fairs']) | async"
                  (click)="openSubMenu()"
                  class="header-link">
                  <span i18n="@@uiShell-allFairsLinkLabelMobile">Alle anzeigen</span>
                  <mat-icon class="header-link__icon">chevron_right</mat-icon>
                </a>
                <hr />
                @if (isLoggedIn) {
                <a
                  (click)="closeMenu()"
                  routerLink="/profile"
                  [routerLinkActiveOptions]="{
                    matrixParams: 'ignored',
                    queryParams: 'ignored',
                    paths: 'exact',
                    fragment: 'ignored'
                  }"
                  class="header-link"
                  routerLinkActive="header-link-active">
                  <span i18n="@@uiShell-sideNavAccountLinkLabel">Mein Konto</span>
                  <mat-icon class="header-link__icon">person</mat-icon>
                </a>
                }

                <a
                  (click)="closeMenu()"
                  [routerLink]="['profile', 'business-card']"
                  class="header-link"
                  routerLinkActive="header-link-active">
                  <span i18n="@@uiShell-sideNav-businessCardLinkLabel">Digitale Visitenkarte</span>
                  <mat-icon
                    class="header-link__icon header-link__icon--business-card"
                    svgIcon="business-card"></mat-icon>
                </a>

                @if (qrCodeScannerEnabled$ | async) {
                <a
                  (click)="closeMenu()"
                  [routerLink]="['scanner']"
                  class="header-link"
                  routerLinkActive="header-link-active">
                  <span i18n="@@uiShell-sideNav-scannerLinkLabel">Scanner</span>
                  <mat-icon class="header-link__icon">qr_code_scanner</mat-icon>
                </a>
                }
                <a
                  (click)="closeMenu()"
                  [routerLink]="['tickets']"
                  class="header-link"
                  routerLinkActive="header-link-active">
                  <span i18n="@@uiShell-sideNavTicketsLinkLabel">Tickets</span>
                  <mat-icon class="header-link__icon">confirmation_number</mat-icon>
                </a>
                @if (watchlistEnabled$ | async) {
                <a
                  (click)="closeMenu()"
                  [routerLink]="['watchlist']"
                  class="header-link"
                  routerLinkActive="header-link-active">
                  <span i18n="@@uiShell-sideNavWatchlistLinkLabel">Merkliste</span>
                  <mat-icon class="header-link__icon">star</mat-icon>
                </a>
                } @if ((selfServiceEnabled$ | async) && selfServiceLink) {
                <a
                  (click)="closeMenu()"
                  [href]="selfServiceLink"
                  target="_blank"
                  class="header-link"
                  routerLinkActive="header-link-active">
                  <span i18n="@@uiShell-sideNavSelfServiceLinkLabel">Self Service</span>
                  <mat-icon class="header-link__icon">tv_options_input_settings</mat-icon>
                </a>
                } } @if (isLoggedIn) {
                <hr />
                <button (click)="doLogout()" class="header-mobile-navigation-logout-button header-link mat-body-2">
                  <span i18n="@@uiShell-sideNavLogoutLinkLabel">Abmelden</span>
                  <mat-icon class="header-link__icon">logout</mat-icon>
                </button>
                }
              </div>
              }
            </mat-sidenav>
            <mat-sidenav-content
              class="sidenav-content__inner"
              [class.blurred]="isMenuOpen"
              [class.show-mobile-bottom-bar]="showMobileBottomBar$ | async">
              <bau365-shell-header
                (burgerMenuToggle)="$event ? openOrCloseMenu() : closeMenu()"
                [isLoggedIn]="isLoggedIn"
                [givenName]="givenName"
                [familyName]="familyName"
                [initials]="initials"
                [email]="email"
                [loginLink]="loginLink"
                [profileImage]="profileImage$ | async"
                [selfServiceLink]="selfServiceLink"
                (logout)="doLogout()"></bau365-shell-header>
              <main [ngClass]="{ 'state-logged-in': isLoggedIn, 'submenu-is-sticky': isSubmenuActive }">
                <router-outlet></router-outlet>
              </main>
              @if (showFooter) {
              <bau365-shell-footer
                [isLoggedIn]="isLoggedIn"
                [showMobileBottomBar]="showMobileBottomBar$ | async"
                (burgerMenuToggle)="$event ? openOrCloseMenu() : closeMenu()"></bau365-shell-footer>
              }
            </mat-sidenav-content>
          </mat-sidenav-container>
        </mat-sidenav-content>
      </mat-sidenav-container>
    </mat-sidenav-content>
  </mat-sidenav-container>
  @if (showMobileBottomBar$ | async) { @if (fairsConfiguration$ | async; as fairsConfiguration) {
  <bau365-shell-mobile-bottom-bar
    [configuration]="fairsConfiguration"
    [qrCodeScannerEnabled]="qrCodeScannerEnabled$ | async"
    [isLoggedIn]="isLoggedIn"></bau365-shell-mobile-bottom-bar>
  } }
</div>
